<template>
  <div>
    <h1>Associar provedores à disponibilidade -  {{ this.disponibilidadeSelecionada.nome || this.disponibilidadeSelecionada.name }}</h1>

    <div
      class="container-dados-disponibilidade"
      v-if="!loadingDisponibilidade && (listaDadosAssociados.length || listaDadosDisponiveis.length)"
    >
      <label>Disponibilidade: {{ this.disponibilidadeSelecionada.nome || this.disponibilidadeSelecionada.name }}</label>
    </div>

    <SGPAlertaComponent v-else />

    <SGPAssociarComponent
      v-if="listaDadosAssociados.length || listaDadosDisponiveis.length"
      tituloAssociados="Provedores"
      tituloDisponiveis="Provedores"
      :dadoAssociado="listaDadosAssociados"
      :dadoDisponivel="listaDadosDisponiveis"
      @sgpSalvarAssociacoesEmit="provedoresParaAssociar"
    />

    <SGPLoadingComponent v-if="loadingDisponibilidade" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ProvedoresDisponibilidadePage',

  data() {
    return {
      listaDadosAssociados: [],
      listaDadosDisponiveis: []
    }
  },

  async created() {
    await this.listarProvedores()
    await this.recuperarDisponibilidadeComProvedores(this.$route.params.disponibilidade)

    this.atualizarListaDeDadosAssociadosENaoAssociados()
  },

  computed: {
    ...mapGetters('ctrlDisponibilidade', [
      'loadingDisponibilidade',
      'listaDeProvedores',
      'disponibilidadeSelecionadaComProvedores'
    ]),

    disponibilidadeSelecionada() {
      return this.disponibilidadeSelecionadaComProvedores
    },

    provedoresAssociados() {
      if (!this.disponibilidadeSelecionadaComProvedores?.provedores) return []

      return this.disponibilidadeSelecionadaComProvedores.provedores.map(provedor => ({
        id: provedor.id,
        descricao: provedor.nome || provedor.name,
        selecionado: false
      }))
    },

    provedoresDisponiveis() {
      const associadosIds = this.disponibilidadeSelecionadaComProvedores?.provedores?.map(p => p.id) || []
      const todosProvedores = this.listaDeProvedores || []

      return todosProvedores
        .filter(provedor => !associadosIds.includes(provedor.id))
        .map(provedor => ({
          id: provedor.id,
          descricao: provedor.nome || provedor.name,
          selecionado: false
        }))
    }
  },

  methods: {
    ...mapActions('ctrlDisponibilidade', [
      'listarProvedores',
      'recuperarDisponibilidadeComProvedores',
      'associarProvedoresADisponibilidade'
    ]),

    atualizarListaDeDadosAssociadosENaoAssociados() {
      this.listaDadosAssociados = this.provedoresAssociados
      this.listaDadosDisponiveis = this.provedoresDisponiveis
    },

    provedoresParaAssociar(value) {
      const listaIdsAssociados = value.listaAssociados.map(provedor => provedor.id)

      const payload = {
        provedores: listaIdsAssociados,
        disponibilidadeId: this.$route.params.disponibilidade
      }

      this.associarProvedoresADisponibilidade(payload)
    }
  }
}
</script>

<style scoped>
.container-dados-disponibilidade {
  margin-bottom: 20px;
}
</style>

